import React, { useState, useEffect } from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import ScienceIcon from '@mui/icons-material/Science';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import HomeIcon from '@mui/icons-material/Home';
import photoshow1 from '../../assets/photoshow1.png';
import photoshow2 from '../../assets/photoshow2.jpg';
import photoshow3 from '../../assets/photoshow3.jpg';
import photoshow4 from '../../assets/photoshow4.jpg';

export const Page7 = () => {
    const cardsData = [
        {
            title: 'Dermatologist-developed, focused on effective formulations',
            description: 'Our products are developed by dermatologists with a focus on creating effective formulations that deliver visible results for your skin.',
            icon: ScienceIcon
        },
        {
            title: 'Powered by European skincare technology for targeted solutions',
            description: 'Leveraging advanced European skincare technology, we provide targeted solutions designed to address specific skin concerns with precision and efficacy.',
            icon: PrecisionManufacturingIcon
        },
        {
            title: 'Professional-grade skincare, now available at home',
            description: 'Experience professional-grade skincare formulations in the comfort of your home, bringing salon-quality results to your daily routine.',
            icon: HomeIcon
        },
    ];

    const images = [photoshow1, photoshow2, photoshow3, photoshow4]; // Array of images to cycle through
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000); // Change image every 3 seconds

        return () => clearInterval(interval); // Clear interval on component unmount
    }, [images.length]);

    return (
        <Container
            maxWidth={false}
            id="product-features"
            sx={{
                position: 'relative',
                width: '100%',
                height: { xs: '350vh', md: '270vh' },
                backgroundColor: '#fefaf4',
                overflowX: 'clip',
            }}
        >
            <Grid container>
                {/* Left Cards */}
                <Grid item md={6} sx={{ paddingTop: '40px', paddingRight: '20px', paddingLeft: '20px' }}>
                    <Box
                        style={{
                            position: 'sticky',
                            top: '30px', // Keeps the title sticky at the top
                            right: 0,
                            maxWidth: '100%',
                            borderRadius: '20px',
                            objectFit: 'cover',
                            height: 'auto'
                        }}
                        sx={{
                            top: { xs: '10px', md: '50px' },
                            left: { xs: '20px', md: '5%' },
                            paddingRight: { xs: '20px', md: '50px' },
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: 'ClaireMurphy',
                                fontSize: { xs: '24px', md: '40px' }, // Adjusted for mobile
                                fontWeight: 400,
                                lineHeight: { xs: '30px', md: '46px' },
                                textAlign: 'left',
                                color: 'rgba(61, 61, 61, 1)',
                                marginBottom: '40px',
                                position: 'sticky',
                                top: '30px',
                                zIndex: 20,
                                paddingTop: '10px',
                            }}
                        >
                            WHY BIELENDA SUPREMELAB?
                        </Typography>
                    </Box>

                    {cardsData.map((card, index) => (
                        <Box
                            key={index}
                            sx={{
                                width: '100%',
                                maxWidth: '100%',
                                padding: '30px',
                                height: '80vh',
                                borderRadius: '20px',
                                backgroundColor: '#fff',
                                border: '1px solid rgba(221, 221, 221, 1)',
                                marginBottom: '30px',
                                position: 'sticky',
                                top: `${100}px`,
                                zIndex: 10 + index,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                justifyContent: 'center', // Center the content within the card
                                textAlign: 'center',
                            }}
                        >
                            <Box sx={{ marginBottom: '20px', color: 'rgba(61, 61, 61, 1)' }}>
                                <card.icon sx={{ fontSize: { xs: '48px', md: '64px' } }} />
                            </Box>
                            <Typography
                                sx={{
                                    fontFamily: 'Quicksand',
                                    fontSize: { xs: '36px', md: '60px' }, // Adjusted for mobile
                                    fontWeight: 300,
                                    lineHeight: { xs: '45px', md: '75px' }, // Adjusted for mobile
                                    letterSpacing: '-0.03em',
                                    textAlign: 'left',
                                    color: 'rgba(61, 61, 61, 1)',
                                    marginBottom: '20px',
                                }}
                            >
                                {card.title}
                            </Typography>

                            <Typography
                                sx={{
                                    fontFamily: 'Quicksand',
                                    fontSize: { xs: '14px', md: '18px' }, // Adjusted for mobile
                                    fontWeight: 400,
                                    textAlign: 'left',
                                    lineHeight: { xs: '20px', md: '26.1px' }, // Adjusted for mobile
                                    color: 'rgba(61, 61, 61, 1)',
                                }}
                            >
                                {card.description}
                            </Typography>
                        </Box>
                    ))}
                </Grid>

                {/* Right Image */}
                <Grid item md={6} sx={{ paddingTop: '50px', paddingBottom: '50px' }}>
                    <Box
                        sx={{
                            position: 'sticky',
                            top: '30px',
                            width: '100%',
                            height: { xs: '70vh', md: '85vh' },
                            borderRadius: '20px',
                            overflow: 'hidden',
                        }}
                    >
                        <img
                            src={images[currentImageIndex]} // Display current image
                            alt="Product"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: 'block',
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};
